// components/LoadingIndicator.tsx
import React from 'react';
import { CircularProgress, Typography, Box } from '@mui/material';

interface LoadingIndicatorProps {
  text?: string;
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ text = 'Loading...' }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <CircularProgress color="primary" />
      <Typography variant="body1" color="textSecondary" mt={2}>
        {text}
      </Typography>
    </Box>
  );
};

export default LoadingIndicator;